/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDetailRocketFileVo } from './OrderDetailRocketFileVo';
import {
    OrderDetailRocketFileVoFromJSON,
    OrderDetailRocketFileVoFromJSONTyped,
    OrderDetailRocketFileVoToJSON,
    OrderDetailRocketFileVoToJSONTyped,
} from './OrderDetailRocketFileVo';

/**
 * 
 * @export
 * @interface OrderDetailRocketWarehouseVo
 */
export interface OrderDetailRocketWarehouseVo {
    /**
     * 收件人姓名
     * @type {string}
     * @memberof OrderDetailRocketWarehouseVo
     */
    receiverName?: string;
    /**
     * 收件人电话
     * @type {string}
     * @memberof OrderDetailRocketWarehouseVo
     */
    mobileNo?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof OrderDetailRocketWarehouseVo
     */
    address?: string;
    /**
     * 文件列表
     * @type {Array<OrderDetailRocketFileVo>}
     * @memberof OrderDetailRocketWarehouseVo
     */
    files?: Array<OrderDetailRocketFileVo>;
}

/**
 * Check if a given object implements the OrderDetailRocketWarehouseVo interface.
 */
export function instanceOfOrderDetailRocketWarehouseVo(value: object): value is OrderDetailRocketWarehouseVo {
    return true;
}

export function OrderDetailRocketWarehouseVoFromJSON(json: any): OrderDetailRocketWarehouseVo {
    return OrderDetailRocketWarehouseVoFromJSONTyped(json, false);
}

export function OrderDetailRocketWarehouseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailRocketWarehouseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'address': json['address'] == null ? undefined : json['address'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(OrderDetailRocketFileVoFromJSON)),
    };
}

export function OrderDetailRocketWarehouseVoToJSON(json: any): OrderDetailRocketWarehouseVo {
    return OrderDetailRocketWarehouseVoToJSONTyped(json, false);
}

export function OrderDetailRocketWarehouseVoToJSONTyped(value?: OrderDetailRocketWarehouseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'address': value['address'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(OrderDetailRocketFileVoToJSON)),
    };
}

